const Logo = () => {
  return (
    <img
      alt={"tutoria-Logo"}
      src={"/TutoriaLogo.png"}
      style={{
        width: "150px",
        height: "100%",
      }}
    />
  );
};

export default Logo;
